<template>
    <!-- Desktop dialog using UiModal -->
    <UiModal
        v-if="!isMobile"
        :is-open="showNextCardMethodModal"
        title="How does My Next Card work?"
        @close="closeModal"
        width="800px"
    >
        <template #content>
            <div class="flex flex-col items-center gap-6 px-6 py-4">
                <img
                    src="/images/mynextcard.png"
                    class="w-40 h-auto"
                    alt="My Next Card"
                />
                <div class="text-slate-800 dark:text-slate-200 text-sm leading-6 space-y-4">
                    <p>
                        My Next Card looks at your current credit cards, points
                        balances, credit score, and other factors to recommend
                        the best credit cards for you and you alone.
                    </p>

                    <p>
                        These recommendations are driven by the above factors as
                        well as our own analysis of the best credit card offers
                        on the market. We rank these offers by looking at a
                        card's signup bonus, spending rewards, benefits, and
                        annual fee to determine which cards will offer more
                        value to the average person.
                    </p>

                    <p>
                        Of course everyone's circumstances are a little bit
                        different, so we encourage you to compare multiple
                        credit card offers to be sure you are making the right
                        choice for you.
                    </p>
                </div>
            </div>
        </template>
    </UiModal>

    <!-- Mobile using UiModalMobile -->
    <UiModalMobile
        v-if="isMobile"
        :is-open="showNextCardMethodModal"
        title="How does My Next Card work?"
        @close="closeModal"
    >
        <template #content>
            <div class="flex w-full flex-col items-center gap-6">
                <img
                    src="/images/mynextcard.png"
                    class="w-40 h-auto"
                    alt="My Next Card"
                />
                <div class="text-slate-800 dark:text-slate-200 text-sm leading-6 space-y-4">
                    <p>
                        My Next Card looks at your current credit cards, points
                        balances, credit score, and other factors to recommend
                        the best credit cards for you and you alone.
                    </p>
                    <p>
                        These recommendations are driven by the above factors as
                        well as our own analysis of the best credit card offers
                        on the market. We rank these offers by looking at a
                        card's signup bonus, spending rewards, benefits, and
                        annual fee to determine which cards will offer more
                        value to the average person.
                    </p>
                    <p>
                        Of course everyone's circumstances are a little bit
                        different, so we encourage you to compare multiple
                        credit card offers to be sure you are making the right
                        choice for you.
                    </p>
                </div>
            </div>
        </template>
        <template #footer>
            <button
                type="button"
                class="w-full h-11 rounded-lg bg-slate-800 dark:bg-slate-700 text-white text-sm font-medium"
                @click="closeModal"
            >
                Got it
            </button>
        </template>
    </UiModalMobile>
</template>
<script setup>
import { computed } from 'vue';
import { useAppStore } from '@/store/app';
import { useIsMobile } from '@/composables/useIsMobile';
import UiModal from '@/components/ui/modal/ui-modal.vue';
import UiModalMobile from '@/components/ui/modal/ui-modal-mobile.vue';

const appStore = useAppStore();
const { isMobile } = useIsMobile();

const showNextCardMethodModal = computed(
    () => appStore.showNextCardMethodModal
);

const closeModal = () => {
    appStore.setShowNextCardMethodModal(false);
};
</script>
